
/* ===== VELANTIS_AMB_GROUPED — ambientales agrupados por colección ===== */
(function(){
  var COLS={"Hoteles":["VIDANTA","VIDANTALUXXE","ATELIER","WYNN","ARIA","MGM","HARDROCK","BVLGARITOKYO","ROYALCHAMPAGNE","XCARET","XCARETPARQUE"],"Tiendas":["INNOVASPORT","PALACIO","ZARAHOME","MUYMUCHO","MAHOGANYTEAKWOOD","EMWA","LINCOLN","ABERCROMBIE"],"Perfume":["SANTAL33","BERGAMOTE22","BACCARAT","LIMEBASILMANDARIN","AVENTUS","TOBACCOVANILLE","ERBAPURA","LAYTON","FRENESI","ORGANS","THENOIR29"],"Otros":["CARNEW","LEATHER","TENEGROLELABO","MADERASDELMEDITERRANEO","LINOYALOE","AMBARCEDRO","JAPANESELOTUS","WHITETEA"]};
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function norm(s){ return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function CAT(){ return window.VELANTIS_CAT||[]; }
  function colOf(name){ var n=norm(name); for(var k in COLS){ if(COLS[k].indexOf(n)>=0) return k; } return 'Otros'; }
  function card(r,col){
    var name=r[0], notes=[r[5],r[6],r[7]].filter(Boolean).join(', ');
    return '<article class="oil-card" data-lhs="'+esc('AMB:'+name)+'" data-name="'+esc(name)+'" data-price="449" data-img="amb-img" data-sub="Aroma de ambiente · 250 ml" tabindex="0">'+
      '<div class="oil-img amb-card-img"></div>'+
      '<div class="oil-body"><div class="oil-cat">'+esc(col)+'</div><h3>'+esc(name)+'</h3>'+
      '<p class="oil-desc">Aroma de ambiente · 250 ml</p>'+
      (notes?'<p class="oil-notes">'+esc(notes.charAt(0).toUpperCase()+notes.slice(1))+'</p>':'')+
      '<div class="oil-price">$449 <small>MXN</small></div>'+
      '<button class="add" type="button">Agregar al carrito</button></div></article>';
  }
  function render(){
    var box=document.getElementById('ambCatalog'); if(!box) return;
    var amb=CAT().filter(function(r){return r[1]==='Ambiental';});
    var order=['Hoteles','Tiendas','Perfume','Otros'], groups={};
    amb.forEach(function(r){ var c=colOf(r[0]); (groups[c]=groups[c]||[]).push(r); });
    box.innerHTML=order.map(function(col){
      var list=groups[col]||[]; if(!list.length) return '';
      return '<div class="oil-group"><div class="oil-group-s">Colección</div><h3 class="oil-group-h">'+col+'</h3>'+
        '<div class="oil-grid">'+list.map(function(r){return card(r,col);}).join('')+'</div></div>';
    }).join('');
    /* 4-sep: las tarjetas nacen con opacidad 0 y esperan la clase v-listo, que
       index-46 pone cuando el motor resuelve su hueco. Al entrar por navegacion
       (la rejilla se redibuja) esa senal no llegaba y la coleccion se veia vacia.
       Aqui se marcan por su cuenta. */
    setTimeout(function(){ var v=box.querySelectorAll('.oil-card:not(.v-listo)'); for(var i=0;i<v.length;i++) v[i].classList.add('v-listo'); }, 400);

    if(!box._wired){ box._wired=1; box.addEventListener('click',function(e){
      if(e.target.closest('.add')) return;
      var c=e.target.closest('.oil-card'); if(!c) return;
      location.hash='#/lhs/'+encodeURIComponent(c.getAttribute('data-lhs'));
    }); }
  }
  var cIv=null, cCur=0;
  function carousel(){
    var car=document.getElementById('ambCarousel'); if(!car) return;
    var slides=car.querySelectorAll('.ambc-slide'), dots=car.querySelectorAll('.ambc-dot');
    if(slides.length<2){ return; }
    function go(i){ cCur=(i+slides.length)%slides.length;
      [].forEach.call(slides,function(s,k){ s.classList.toggle('on',k===cCur); });
      [].forEach.call(dots,function(dd,k){ dd.classList.toggle('on',k===cCur); }); }
    function restart(){ clearInterval(cIv); cIv=setInterval(function(){ go(cCur+1); },5000); }
    if(!car._wired){ car._wired=1;
      [].forEach.call(dots,function(dd){ dd.addEventListener('click',function(){ go(+dd.getAttribute('data-i')); restart(); }); });
      car.addEventListener('mouseenter',function(){ clearInterval(cIv); });
      car.addEventListener('mouseleave',restart);
    }
    restart();
  }
  function route(){
    var isA=/^#\/ambientales\/?$/.test(location.hash||'');
    document.body.classList.toggle('ambgrouped',isA);
    var pg=document.getElementById('ambientalesPage'); if(pg) pg.hidden=!isA;
    if(isA){ render(); carousel(); window.scrollTo(0,0); } else { clearInterval(cIv); }
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
